import { MessageProxy } from "@intelligems/ig-embedded-preview";
import { AppListenerMiddleware, RootState } from "@src/store";
import { basicModSlice } from "@src/store/slices/experienceBuilder/basicMod/slice";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraft";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

const { getEmbeddedNodes } = experienceBuilderSlice.selectors;

export const setupMissingNodesListener = (
  middleware: AppListenerMiddleware,
  messageProxy: MessageProxy
) =>
  middleware.startListening({
    predicate: (_, curr, prev) => predicate(curr, prev),
    effect: (_, { dispatch, getState }) => {
      const draft = getVariationDraft(getState());
      if (draft?.type === "text" || draft?.type === "image") {
        const node = getEmbeddedNodes(getState())[draft.selector];
        if (node) {
          dispatch(
            basicModSlice.actions.setDraft({
              ...draft,
              nodes: [node],
              html: draft.html ?? node.html,
            })
          );
        } else {
          messageProxy.send("ig-getNodeForSelector", {
            selector: draft.selector,
          });
        }
      }
    },
  });

const predicate = (state: RootState, prev: RootState) => {
  const draft = getVariationDraft(state);
  if (!draft) return false;
  if (draft.type !== "text" && draft.type !== "image") return false;
  if (draft.nodes.length > 0) return false;

  const prevDraft = getVariationDraft(prev);
  return draft.id !== prevDraft?.id;
};
